import { useEffect, useState, useContext } from "react";
import {
  getCancellationPreview,
  cancelAppointment,
} from "../api/appointmentApi";
import { BarbershopContext } from "../providers/useProvider";
const useAppointmentCancellation = (token) => {
  const [loading, setLoading] = useState(true);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isCancelling, setIsCancelling] = useState(false);
  const { config } = useContext(BarbershopContext);
  useEffect(() => {
    if (!token) {
      setError("Invalid cancellation link.");
      setLoading(false);
      return;
    }

    const loadPreview = async () => {
      if (config) {
        try {
          const data = await getCancellationPreview(token, config.id);
          if (data.isSuccess) {
            setPreview(data.value);
          } else {
            setError(data.errors[0]);
          }
        } catch {
          setError("Unable to load appointment.");
        } finally {
          setLoading(false);
        }
      }
    };

    loadPreview();
  }, [token, config]);

  const cancel = async () => {
    setIsCancelling(true);
    setError("");

    try {
      const response = await cancelAppointment(token, config.id);

      if (response.data.isSuccess) {
        setSuccess(response.data.value);
      } else {
        setError(response.data.error);
      }
    } catch {
      setError("Cancellation failed.");
    } finally {
      setIsCancelling(false);
    }
  };

  return {
    loading,
    preview,
    error,
    success,
    isCancelling,
    cancel,
  };
};
export default useAppointmentCancellation;
